// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610011923/js/" + chunkId + "." + {"44":"e884ff06","225":"7e2e924a","481":"5e369be7","486":"aaba7516","770":"2374b596"}[chunkId] + ".0.639476507900639.chunk.js";
};